import { VKLang } from './L';

export const importLocale = (lng: string): Promise<VKLang> => {
  return import(`./locales/${lng}.json`).then((data) => data.default);
};
